export default __webpack_public_path__ + "static/media/scroll-pointer-icon.8a74e1a3.svg";